import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-user-01',
  imports: [],
  templateUrl: './user-01.html',
  styleUrl: './user-01.scss',
})
export class User01 {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
